__turbopack_context__.v({
  "background": "ap_kDq_background",
  "backgroundImage": "ap_kDq_backgroundImage",
  "content": "ap_kDq_content",
  "description": "ap_kDq_description",
  "foreground": "ap_kDq_foreground",
  "heading": "ap_kDq_heading",
  "overlay": "ap_kDq_overlay",
  "root": "ap_kDq_root",
  "srOnly": "ap_kDq_srOnly",
  "textBlock": "ap_kDq_textBlock",
});
